import {
  Kamoku,
  HasId,
  ResponseSettingItem,
  SonekiKeisanKmkTypeType,
  sonekiKeisanKmkTypeType
} from '@/repositories/keiei-joho/data'
import { CorporationTypeType } from '@/views/corporation-info/types'

export type ResponseSonekiKeisanSettingItem = HasId & {
  kmkName: string;
  kmkType: SonekiKeisanKmkTypeType;
  isRequiredSettingType1: boolean;
  isRequiredSettingType2To5: boolean;
  setting: ResponseSettingItem;
}

export type ResponseSonekiKeisanSetting = {
  kamokuSources: Kamoku[],
  items: ResponseSonekiKeisanSettingItem[],
  corporationType: CorporationTypeType
}

export type CorporationInfo = {
  corporationName: string,
  location: string,
  medicalCorporationNumber: string,
  corporationType: CorporationTypeType,
}

export interface HasKin {
  kin: number | null;
}

export type SonekiKeisanKmkType = HasKin & {
  kmkName: string;
  kmkType: SonekiKeisanKmkTypeType;
  isRequiredSettingType1: boolean;
  isRequiredSettingType2To5: boolean;
  exportKmkName: string;
}
export function initializeSonekiKeisanKmk (): SonekiKeisanKmkType {
  return {
    kmkName: '',
    kmkType: sonekiKeisanKmkTypeType.HonraiJigyoShueki,
    isRequiredSettingType1: false,
    isRequiredSettingType2To5: false,
    exportKmkName: '',
    kin: 0
  }
}

export type ResponseSonekiKeisanExportLayout = {
  corporationInfo: CorporationInfo,
  kmkTypes: SonekiKeisanKmkType[]
}
